import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import styles from "./UpdateMarks.module.css";
import { customStyles } from "../../../../../pages/customStyles";
import Loader from "../../../Loader";
import { AxiosInstance } from "../../../../../axios";
import { ImageUrlPrefix } from "../../../../../labels";
import { Download } from "@mui/icons-material";
import moment from "moment";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { Dialog, DialogContent } from "@mui/material";
function UpdateMarks() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    UMEVENTID,
    USERIDEM,
    TOMARK,
    ATTESTAT,
    ATTMPNO,
    ATTENDSHEET_MARK,
    BATCHID,
  } = location.state || {};
  const obtainedMarksRef = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ismarkLoding, setIsmarkLoding] = useState(false);
  // get user id from
  const userJSON = sessionStorage.getItem("userDetails");
  let userid_staff = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid_staff = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  // update marks - data for table
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState([]);
  // dropdown options
  // 0:Poor 1:belowAverage 2:Average 3:Good 4:Excellent
  const Options = [
    { value: "4", label: "Excellent" },
    { value: "3", label: "Good" },
    { value: "2", label: "Average" },
    { value: "1", label: "Below Average" },
    { value: "0", label: "Poor" },
  ];

  // comment section use ref
  const hand_writing_ref = useRef(null);
  const key_points_ref = useRef(null);
  const presentation_ref = useRef(null);
  const quality_of_content_ref = useRef(null);
  const quantity_of_facts_ref = useRef(null);
  const heading_ref = useRef(null);
  const highlight_of_fact_ref = useRef(null);
  const pictographics_ref = useRef(null);
  const sub_heading_ref = useRef(null);
  const evaluvated_answer_sheet_ref = useRef(null);
  // marks ref section

  // comment section use state
  const [commentSection, setCommentSection] = useState({
    hand_writing: "",
    hand_writing_label: "",
    key_points: "",
    key_points_label: "",
    presentation: "",
    presentation_label: "",
    quality_of_content: "",
    quality_of_content_label: "",
    quantity_of_facts: "",
    quantity_of_facts_label: "",
    heading: "",
    heading_label: "",
    pictographics: "",
    sub_heading: "",
    pictographics_label: "",
    sub_heading_label: "",
    highlight_of_fact: "",
    evaluvated_answer_sheet: null,
    evaluvated_answer_sheet_original_path: null,
  });
  // load table data
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/test/descriptive/stud_details", {
      event_id: UMEVENTID,
      user_id: USERIDEM,
      attempt_no: ATTMPNO,
    })
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const testTableData = res.data.data.testAnswers;
          const AddedData = testTableData.map((data, index) => ({
            ...data,
            user_answer_error: "",
          }));
          setTableData(AddedData);
          const testCommentData = res.data.data.testReport;
          const codata = {
            hand_writing: String(testCommentData[0].hand_writing),
            hand_writing_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].hand_writing)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].hand_writing)
                ).label
              : "",
            key_points: String(testCommentData[0].key_points),
            key_points_label: Options.find(
              (option) => option.value === String(testCommentData[0].key_points)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].key_points)
                ).label
              : "",
            quantity_of_facts: String(testCommentData[0].quantity_facts),
            quantity_of_facts_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].quantity_facts)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].quantity_facts)
                ).label
              : "",
            presentation: String(testCommentData[0].presentation),

            presentation_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].presentation)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].presentation)
                ).label
              : "",
            quality_of_content: String(testCommentData[0].quality_content),
            quality_of_content_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].quality_content)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].quality_content)
                ).label
              : "",

            heading: String(testCommentData[0].headings),
            heading_label: Options.find(
              (option) => option.value === String(testCommentData[0].headings)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].headings)
                ).label
              : "",
            pictographics: String(testCommentData[0].pictographics),
            sub_heading: String(testCommentData[0].sub_heading),
            pictographics_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].pictographics)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].pictographics)
                ).label
              : "",
            sub_heading_label: Options.find(
              (option) =>
                option.value === String(testCommentData[0].sub_heading)
            )
              ? Options.find(
                  (option) =>
                    option.value === String(testCommentData[0].sub_heading)
                ).label
              : "",
            highlight_of_fact: testCommentData[0].highlight_facts,
            evaluvated_answer_sheet: testCommentData[0].descriptive_answer_sheet
              ? testCommentData[0].descriptive_answer_sheet
              : null,
            evaluvated_answer_sheet_original_path:
              testCommentData[0].descriptive_answer_original_sheet,
          };
          setCommentSection(codata);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
    // }, [UMEVENTID]);
  }, []);

  // on change functionality
  const handleObtanedMarks = (e, queNo) => {
    let { value } = e.target;
  
    // Regex: allow only digits and optional 1 decimal with up to 2 digits after it
    const isValidFormat = /^\d*\.?\d{0,2}$/;
  
    // Prevent further typing if more than 2 digits are entered after the dot
    const parts = value.split(".");
    if (parts.length === 2 && parts[1].length > 2) {
      return; // block further input
    }
  
    if (!isValidFormat.test(value)) {
      setTableData((prevData) =>
        prevData.map((item) =>
          item.ques_no === queNo
            ? {
                ...item,
                user_answer: value,
                user_answer_error: "Only numeric values are allowed.",
              }
            : item
        )
      );
      setError((prevError) => ({
        ...prevError,
        [`user_answer_${queNo}`]: "Only numeric values are allowed.",
      }));
    } else {
      setTableData((prevData) =>
        prevData.map((item) =>
          item.ques_no === queNo
            ? {
                ...item,
                user_answer: value,
                user_answer_error: "",
              }
            : item
        )
      );
      setError((prevError) => ({
        ...prevError,
        [`user_answer_${queNo}`]: "",
      }));
    }
  };  
  

  // for validate marks and comment section
  const validateMarksComment = (dfata, COMSEC) => {
    // obtainedMarks.current.push(React.createRef());
    const errors = {};
    if (dfata.length > 0) {
      const dfataData = dfata.map((OB, i) => {
        let updatedOB = { ...OB };
        if (!OB.user_answer) {
          updatedOB.user_answer_error = "Obtained marks cannot be empty";
          errors[`user_answer_${OB.ques_no}`] =
            "Obtained marks cannot be empty"; // Collect errors for each ID
        }
        if (OB.user_answe && isNaN(OB.user_answer)) {
          updatedOB.user_answer_error = "Obtained Marks must be a valid number";
          errors[`user_answer_${OB.ques_no}`] =
            "Obtained Marks must be a valid number";
        }
        if (OB.user_answer && OB.user_answer > OB.marks) {
          updatedOB.user_answer_error =
            "Obtained marks must be less than or equal to the maximum marks";
          errors[`user_answer_${OB.ques_no}`] =
            "Obtained marks cannot be empty"; // Collect errors for each ID
        }
        return updatedOB;
      });

      setTableData(dfataData);
    }
    if (!COMSEC.hand_writing) {
      errors.hand_writing = "Please select an option for hand writing";
    }
    if (!COMSEC.key_points) {
      errors.key_points = "   Please select an option for key points";
    }
    if (!COMSEC.presentation) {
      errors.presentation = "  Please select an option for presentation";
    }
    if (!COMSEC.quality_of_content) {
      errors.quality_of_content =
        "Please select an option for quality of content";
    }
    if (!COMSEC.quantity_of_facts) {
      errors.quantity_of_facts =
        "  Please select an option for quantity of facts";
    }
    if (!COMSEC.pictographics) {
      errors.pictographics = " Please select an option for pictographics";
    }
    if (!COMSEC.heading) {
      errors.heading = " Please select an option for headings";
    }
    if (!COMSEC.sub_heading) {
      errors.sub_heading = " Please select an option for sub headings";
    }
    if (!COMSEC.highlight_of_fact) {
      errors.highlight_of_fact = "Please enter your final comments";
    }
    if (!COMSEC.evaluvated_answer_sheet) {
      errors.evaluvated_answer_sheet =
        "Please upload the evaluated answer sheet";
    }
    validateFocusCommentSection(COMSEC, dfata);
    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO, dttt) => {
    if (!COMSECFO.hand_writing) {
      hand_writing_ref.current.focus();
    } else if (!COMSECFO.key_points) {
      key_points_ref.current.focus();
    } else if (!COMSECFO.presentation) {
      presentation_ref.current.focus();
    } else if (!COMSECFO.quality_of_content) {
      quality_of_content_ref.current.focus();
    } else if (!COMSECFO.quantity_of_facts) {
      quantity_of_facts_ref.current.focus();
    } else if (!COMSECFO.pictographics) {
      pictographics_ref.current.focus();
    } else if (!COMSECFO.heading) {
      heading_ref.current.focus();
    } else if (!COMSECFO.sub_heading) {
      sub_heading_ref.current.focus();
    } else if (!COMSECFO.highlight_of_fact) {
      highlight_of_fact_ref.current.focus();
    } else if (!COMSECFO.evaluvated_answer_sheet) {
      evaluvated_answer_sheet_ref.current.focus();
    }
    if (dttt.length > 0) {
      dttt.some((OB, i) => {
        if (
          !OB.user_answer ||
          isNaN(OB.user_answer) ||
          OB.user_answer > OB.marks
        ) {
          obtainedMarksRef.current[i]?.focus();
          return true; // Stop further iteration
        }
        return false;
      });
    }
  };

  // save marks function
  const handleSaveMark = async (e) => {
    const errors = validateMarksComment(tableData, commentSection);
    const allErrorsFilled = tableData.every(
      (ro) => ro.user_answer !== "" && ro.user_answer_error === ""
    );
    if (Object.keys(errors).length === 0 && allErrorsFilled === true) {
      try {
        const funsavemark = await save_mark_obtainer_marks(tableData);

        if (funsavemark) {
          setIsmarkLoding(true);
          save_mark_comment_sec(commentSection);
        } else {
          setIsmarkLoding(false);
        }
      } catch (error) {
        setIsmarkLoding(false);
        console.error("Error saving marks:", error);
      }
    } else {
      setError(errors);
    }
  };

  // comment select dropdown

  const handlecomchange_select = (optionkk, ename) => {
    if (optionkk) {
      setCommentSection((prevFormData) => ({
        ...prevFormData,
        [ename]: optionkk.value,
        [`${ename}_label`]: optionkk.label,
      }));
      setError({
        ...error,
        [ename]: "",
      });
    } else {
      setCommentSection((prevFormData) => ({
        ...prevFormData,
        [ename]: "",
        [`${ename}_label`]: "",
      }));
      setError({
        ...error,
        [ename]: "",
      });
    }
  };

  // comment section on change functionality

  const handlecomchange = (e) => {
    const { name, value, files } = e.target;
    if (name === "evaluvated_answer_sheet") {
      if (files && files.length > 0) {
        const evaluvated_answer_sheets = files[0];
        setCommentSection({
          ...commentSection,
          evaluvated_answer_sheet: null,
          evaluvated_answer_sheet_original_path: null,
        });
        if (files[0].type == "application/pdf") {
          const formData = new FormData();
          formData.append("evaluvated_answer_sheet", evaluvated_answer_sheets);
          AxiosInstance.post("api/upload/", formData)
            .then((res) => {
              setCommentSection({
                ...commentSection,
                evaluvated_answer_sheet: res.data.path,
                evaluvated_answer_sheet_original_path: res.data.originalname,
              });
            })
            .catch((error) => {
              setError({
                ...error,
                [name]: "Evaluated sheet file size is large",
              });
              setCommentSection({
                ...commentSection,
                evaluvated_answer_sheet: "",
                evaluvated_answer_sheet_original_path: "",
              });
              return error;
            });
          setError({
            ...error,
            [name]: "",
          });
        } else {
          setError({
            ...error,
            [name]: "Evaluated answer sheet must be in pdf",
          });
          setCommentSection({
            ...commentSection,
            evaluvated_answer_sheet: null,
            evaluvated_answer_sheet_original_path: null,
          });
        }
      } else {
        setCommentSection({
          ...commentSection,
          evaluvated_answer_sheet: null,
          evaluvated_answer_sheet_original_path: null,
        });
        setError({
          ...error,
          [name]: "",
        });
      }
    } else {
      setCommentSection((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      setError({
        ...error,
        [name]: "",
      });
    }
  };
  // save mark for marks obtained section

  const save_mark_obtainer_marks = async (TDATA) => {
    const save_mdata = {
      user_id: USERIDEM,
      attempt_no: ATTMPNO ? ATTMPNO : 1,
      created_by: userid_staff, // updated staff id
      created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
      user_marks: TDATA.map((kl) => ({
        batch_id: BATCHID,
        event_pk: kl.event_id,
        question_pk: kl.id,
        user_marks: kl.user_answer,
      })),
    };

    try {
      const res = await AxiosInstance.post(
        "api/test/descriptive/upload_user_mark",
        save_mdata
      );

      if (res.data.status === true) {
        return true;
      } else {
        Swal.fire({
          title: "Failure",
          text: res.data.message,
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return false;
      }
    } catch (error) {
      console.error("Error in saving marks:", error);
      return false;
    }
  };

  // save mark for comment section

  const save_mark_comment_sec = (COMKSE) => {
    let save_mdata = {
      user_id: USERIDEM,
      created_by: userid_staff, //uploaded staff user_id
      created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
      batch_pk: BATCHID,
      event_pk: UMEVENTID,
      type: "1", // default as test
      attendance_status: ATTESTAT ? ATTESTAT : 1, // default as 1 - present status
      attempt_no: ATTMPNO ? ATTMPNO : 1,
      tot_marks: TOMARK,
      tot_correct_marks: 0,
      marks_obtained: 0,
      marks_in_perc: 0,
      hand_writing: parseInt(COMKSE.hand_writing),
      key_points: parseInt(COMKSE.key_points),
      presentation: parseInt(COMKSE.presentation),
      quality_content: parseInt(COMKSE.quality_of_content),
      quantity_facts: parseInt(COMKSE.quantity_of_facts),
      pictographics: parseInt(COMKSE.pictographics),
      headings: parseInt(COMKSE.heading),
      sub_heading: parseInt(COMKSE.sub_heading),
      highlight_facts: COMKSE.highlight_of_fact,
      descriptive_answer_sheet: COMKSE.evaluvated_answer_sheet,
      descriptive_answer_original_sheet:
        COMKSE.evaluvated_answer_sheet_original_path,
    };
    AxiosInstance.post("api/test/descriptive/user_comment", save_mdata)
      .then((res) => {
        if (res.data.status === true) {
          setIsmarkLoding(false);
          navigateToPreviousScreen();
          toast.success(res.data.message);
        } else {
          setIsmarkLoding(false);
          navigateToPreviousScreen();
          toast.error(res.data.message);
        }
      })
      .catch((error) => {
        setIsmarkLoding(false);
        return error;
      });
  };

  // navigate to pervious screen
  const navigateToPreviousScreen = () => {
    navigate("/ViewStudent", {
      state: {
        userIdView: USERIDEM,
        eventIDView: UMEVENTID,
        ANSWERSHEETPATH: ATTENDSHEET_MARK,
        BATCHID: BATCHID,
      },
    });
  };

  const handleButtonClick = () => {
    navigate("/ViewStudent", {
      state: {
        userIdView: USERIDEM,
        eventIDView: UMEVENTID,
        ANSWERSHEETPATH: ATTENDSHEET_MARK,
        BATCHID: BATCHID,
      },
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div className="container-fluid global_container BathHeader tableListHeader">
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">Update Marks</h2>
          </div>

          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  onClick={handleButtonClick}
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to View Student
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  onClick={handleSaveMark}
                  className="primaryButton text-center"
                  variant="primary"
                >
                  Save Marks
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <fieldset className="row m-0 mt-3">
          <legend className="w-auto">Question-wise Marks</legend>
          <div className={`${styles.updateTable} p-0`}>
            {/* Table 1 */}
            <table className={`table `} id="tableListHeader">
              <thead className="TitleHeader">
                <tr>
                  <th id="th">Question Number</th>
                  <th id="th">Maximum Marks</th>
                  <th id="th">Obtained Marks</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 &&
                  tableData.map((row, index) => (
                    <tr key={row.ques_no} className="">
                      <td className={styles.tableDataList}>{row.ques_no}</td>
                      <td className={styles.tableDataList}>{row.marks}</td>
                      <td>
                        <div class="col-md-6 obtmarks">
                          <input
                            ref={(el) => (obtainedMarksRef.current[index] = el)} // Dynamically assign ref
                            name="user_answer"
                            onChange={(e) => handleObtanedMarks(e, row.ques_no)}
                            value={row.user_answer < 0 ? "" : row.user_answer}
                            onKeyDown={handleKeyDown}
                            type="text"
                            class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                            id="user_answer"
                          />
                          {row.user_answer_error && (
                            <span className="error_message">
                              {row.user_answer_error}
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </fieldset>
        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Comments</legend>
            <form className="row g-3">
              {/* -----1------ */}
              <div className="col-md-6">
                <label for="hand_writing" className="form-label confirm_value">
                  Hand Writing
                </label>
                <Select
                  ref={hand_writing_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  isClearable
                  onChange={(opt) =>
                    handlecomchange_select(opt, "hand_writing")
                  }
                  value={
                    commentSection.hand_writing !== ""
                      ? {
                          label: commentSection.hand_writing_label,
                          value: commentSection.hand_writing,
                        }
                      : null
                  }
                  name="hand_writing"
                  styles={customStyles}
                />
                {error.hand_writing && (
                  <span className="error_message">{error.hand_writing}</span>
                )}
              </div>
              <div class="col-md-6">
                <label for="key_points" class="form-label confirm_value ">
                  Key Points
                </label>
                <Select
                  ref={key_points_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  isClearable
                  onChange={(opt) => handlecomchange_select(opt, "key_points")}
                  value={
                    commentSection.key_points !== ""
                      ? {
                          label: commentSection.key_points_label,
                          value: commentSection.key_points,
                        }
                      : null
                  }
                  name="key_points"
                  styles={customStyles}
                />
                {error.key_points && (
                  <span className="error_message">{error.key_points}</span>
                )}
              </div>
              {/* 2 */}
              <div class="col-md-6">
                <label for="presentation" class="form-label confirm_value ">
                  Presentation
                </label>
                <Select
                  ref={presentation_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  onChange={(opt) =>
                    handlecomchange_select(opt, "presentation")
                  }
                  value={
                    commentSection.presentation !== ""
                      ? {
                          label: commentSection.presentation_label,
                          value: commentSection.presentation,
                        }
                      : null
                  }
                  name="presentation"
                  isClearable
                  styles={customStyles}
                />
                {error.presentation && (
                  <span className="error_message">{error.presentation}</span>
                )}
              </div>
              <div class="col-md-6">
                <label
                  for="quantity_of_facts"
                  class="form-label confirm_value "
                >
                  Quantity of Facts{" "}
                </label>
                <Select
                  ref={quantity_of_facts_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  onChange={(opt) =>
                    handlecomchange_select(opt, "quantity_of_facts")
                  }
                  value={
                    commentSection.quantity_of_facts !== ""
                      ? {
                          label: commentSection.quantity_of_facts_label,
                          value: commentSection.quantity_of_facts,
                        }
                      : null
                  }
                  name="quantity_of_facts"
                  isClearable
                  styles={customStyles}
                />
                {error.quantity_of_facts && (
                  <span className="error_message">
                    {error.quantity_of_facts}
                  </span>
                )}
              </div>
              {/* -----3------- */}
              <div class="col-md-6">
                <label
                  for="quality_of_content"
                  class="form-label confirm_value "
                >
                  Quality of Content
                </label>
                <Select
                  ref={quality_of_content_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  isClearable
                  onChange={(opt) =>
                    handlecomchange_select(opt, "quality_of_content")
                  }
                  value={
                    commentSection.quality_of_content !== ""
                      ? {
                          label: commentSection.quality_of_content_label,
                          value: commentSection.quality_of_content,
                        }
                      : null
                  }
                  name="quality_of_content"
                  styles={customStyles}
                />
                {error.quality_of_content && (
                  <span className="error_message">
                    {error.quality_of_content}
                  </span>
                )}
              </div>
              <div class="col-md-6">
                <label for="pictographics" class="form-label confirm_value ">
                  Pictographics
                </label>
                <Select
                  ref={pictographics_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  isClearable
                  onChange={(opt) =>
                    handlecomchange_select(opt, "pictographics")
                  }
                  value={
                    commentSection.pictographics !== ""
                      ? {
                          label: commentSection.pictographics_label,
                          value: commentSection.pictographics,
                        }
                      : null
                  }
                  name="pictographics"
                  styles={customStyles}
                />
                {error.pictographics && (
                  <span className="error_message">{error.pictographics}</span>
                )}
              </div>
              {/* 4 */}
              <div class="col-md-6">
                <label for="heading" class="form-label confirm_value ">
                  Headings
                </label>
                <Select
                  ref={heading_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  onChange={(opt) => handlecomchange_select(opt, "heading")}
                  value={
                    commentSection.heading !== ""
                      ? {
                          label: commentSection.heading_label,
                          value: commentSection.heading,
                        }
                      : null
                  }
                  name="heading"
                  isClearable
                  styles={customStyles}
                />
                {error.heading && (
                  <span className="error_message">{error.heading}</span>
                )}
              </div>
              <div class="col-md-6">
                <label for="sub_heading" class="form-label confirm_value ">
                  Sub Headings
                </label>
                <Select
                  ref={sub_heading_ref}
                  className="shadow-none input-font-size"
                  options={Options}
                  placeholder="Select"
                  onChange={(opt) => handlecomchange_select(opt, "sub_heading")}
                  value={
                    commentSection.sub_heading !== ""
                      ? {
                          label: commentSection.sub_heading_label,
                          value: commentSection.sub_heading,
                        }
                      : null
                  }
                  name="sub_heading"
                  isClearable
                  styles={customStyles}
                />
                {error.sub_heading && (
                  <span className="error_message">{error.sub_heading}</span>
                )}
              </div>
              {/* 5 */}
              <div class="col-12">
                <label
                  for="highlight_of_fact"
                  class="form-label confirm_value "
                >
                  Final Comments
                </label>
                <textarea
                  ref={highlight_of_fact_ref}
                  // className="w-100 rounded p-2 input-font-size"
                  className={`${styles.desc_input} w-100 rounded p-2 input-font-size`}
                  placeholder="Please enter your final comments"
                  id="highlight_of_fact"
                  onChange={(e) => handlecomchange(e)}
                  value={commentSection.highlight_of_fact}
                  name="highlight_of_fact"
                  maxLength={500}
                  // onInput={(e) => {
                  //   e.target.value = e.target.value.replace(
                  //     /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
                  //     ""
                  //   );
                  // }}
                ></textarea>
                {error.highlight_of_fact && (
                  <span className="error_message">
                    {error.highlight_of_fact}
                  </span>
                )}
              </div>
              {/* 6 */}

              <div className="col-lg-6 col-md-12">
                <div className="forms ">
                  <div className="d-flex">
                    <div className="row">
                      <label for="formFile" class={` form-label confirm_value`}>
                        Evaluated Answer Sheet
                      </label>
                    </div>
                    {commentSection.evaluvated_answer_sheet !== "" &&
                      commentSection.evaluvated_answer_sheet !== null && (
                        <div className={"d-flex align-content-center p-0"}>
                          {commentSection.evaluvated_answer_sheet !== "" &&
                            commentSection.evaluvated_answer_sheet !== null && (
                              <>
                                <a
                                  target="_blank"
                                  href={`${ImageUrlPrefix}/${commentSection.evaluvated_answer_sheet}`}
                                  // style={{ marginTop: "15px" }}
                                >
                                  <Download className="download_icon" />
                                </a>
                              </>
                            )}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div
                      className={
                        commentSection.evaluvated_answer_sheet !== "" &&
                        commentSection.evaluvated_answer_sheet !== null
                          ? "col-md-3 col-5 "
                          : "col-md-12"
                      }
                    >
                      <input
                        type="file"
                        className={
                          commentSection.evaluvated_answer_sheet !== "" &&
                          commentSection.evaluvated_answer_sheet !== null
                            ? "InputsSelectFile nn_upload_width"
                            : "InputsSelectFile  vv_upload_width"
                        }
                        placeholder="Enter question path"
                        required
                        id="evaluvated_answer_sheet"
                        onChange={(e) => handlecomchange(e)}
                        name="evaluvated_answer_sheet"
                      />
                    </div>
                    {commentSection.evaluvated_answer_sheet !== "" &&
                      commentSection.evaluvated_answer_sheet !== null && (
                        <div
                          className={
                            "col-md-9 col-7 d-flex  align-content-center p-0"
                          }
                        >
                          <span className="nn_upload_fileevaluator">
                            {commentSection.evaluvated_answer_sheet !== "" &&
                            commentSection.evaluvated_answer_sheet !== null
                              ? commentSection.evaluvated_answer_sheet_original_path
                              : ""}
                          </span>
                          {commentSection.evaluvated_answer_sheet !== "" &&
                            commentSection.evaluvated_answer_sheet !== null && (
                              <>
                                <span
                                  className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                                >
                                  verified
                                </span>
                              </>
                            )}
                        </div>
                      )}
                  </div>

                  {error.evaluvated_answer_sheet && (
                    <span className="error_message">
                      {error.evaluvated_answer_sheet}
                    </span>
                  )}
                </div>
              </div>
            </form>
          </fieldset>
        </div>
        <div className="row mb-3">
          <div className="col-12 dflex justify-content-md-end justify-content-lg-end gap-4">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  onClick={handleButtonClick}
                  className="secondaryButton "
                  variant="secondary"
                >
                  Back to View Student
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  to={"javascript:void(0)"}
                  onClick={handleSaveMark}
                  className="primaryButton"
                  variant="primary"
                >
                  Save Marks
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {ismarkLoding && (
        <Dialog open={ismarkLoding}>
          <DialogContent>
            <div style={{ margin: "15px" }}>
              <p>Please wait...</p>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
export default UpdateMarks;
